module.exports = __webpack_public_path__ + "static/img/bg.ea9cd55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/bg.jpg
// module id = tsNQ
// module chunks = 0